<template>
  <v-card flat class="mx-auto transparent mb-3 mt-2">
    <v-card-actions class="py-1">
      <v-chip
        class="bg-transp subtitle-1"
        color="transparent"
        @click="show = !show"
      >
        {{ $t(day.name) }}
        <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-chip>
      <div class="flex-grow-1"></div>
      
      <transition name="scale-transition">
      <v-btn icon v-show="show" @click="selectAll" color="accent">
        <v-icon>mdi-checkbox-multiple-blank</v-icon>
      </v-btn>
      </transition>
      <transition name="scale-transition">
      <v-btn icon v-show="show" @click="selectNothing" color="secondary">
        <v-icon>mdi-checkbox-multiple-blank</v-icon>
      </v-btn>
      </transition>
      
      <v-badge overlap v-model="showCopy" class="mx-2">
        <template v-slot:badge>
          <v-icon dark>mdi-check</v-icon>
        </template>
        <v-btn icon @click="copyFrom">
        <v-icon>mdi-content-copy</v-icon>
        </v-btn>
      </v-badge>
      
      <v-btn icon @click="copyTo">
        <v-icon>mdi-content-duplicate</v-icon>
      </v-btn>
    </v-card-actions>
    <v-card-text class="py-0" @click="show = !show">
      <div class="d-flex caption font-weight-light cal">
        <div v-for="(n, i) in 48" :key="n" :class="{selected: calendarSetting[iStart + i] == 1}">&nbsp;</div>
      </div>
      <div class="d-flex body-2 font-weight-light hou pt-1">
        <div v-for="hour in mainHours" :key="hour">{{ hour }}</div>
      </div>
    </v-card-text>

    <v-expand-transition>
      <div v-show="show">
        <v-card-text class="pt-4 pb-3">
          <div class="d-flex flex-wrap justify-space-between calendar noselect" :id="iStart">
            <div v-for="(hour, i) in hours" :key="i" :class="{selected: calendarSetting[iStart + i] == 1}">{{ hour }}</div>
          </div>
        </v-card-text>
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
export default {
  props: ['day','dayNr','calendarSetting','iCopy'],
  data: () => ({
    mainHours: ['00','03','06','09','12','15','18','21'],
    hours: ['0:00','0:30','1:00','1:30','2:00','2:30','3:00','3:30','4:00','4:30','5:00','5:30','6:00','6:30','7:00','7:30','8:00','8:30','9:00','9:30','10:00','10:30','11:00','11:30','12:00','12:30','13:00','13:30','14:00','14:30','15:00','15:30','16:00','16:30','17:00','17:30','18:00','18:30','19:00','19:30','20:00','20:30','21:00','21:30','22:00','22:30','23:00','23:30'],
    show: false,
    settings: null,
    iStart: 0
  }),
  computed: {
    showCopy() {
      return this.iCopy == this.iStart
    }
  },
  created () {
    this.iStart = this.dayNr * 48;
  },
  methods: {
    selectNothing() {
      this.$emit('select-nothing', this.iStart);
    },
    selectAll() {
      this.$emit('select-all', this.iStart);
    },
    copyFrom() {
      this.$emit('copy-from', this.iStart);
    },
    copyTo() {
      this.$emit('copy-to', this.iStart);
    }
  },
}
</script>

<style>
.cal div {
  margin-right: 1px;
  /*background-color: rgba(0,0,0,0.07);*/
  background-color: #536dfe;
  border-radius: 2px;
  flex: 1;
}
.theme--dark .cal div {
  /*background-color: rgba(255,255,255,0.05);*/
  background-color: #64b5f6;
}
.hou div {
  margin-right: 1px;
  flex: 1;
}
.cal .selected {
  background-color: #EF3024;
}
.theme--dark .cal .selected {
  background-color: #ef5350;
}
.calendar div {
  width: 15.4%;
  background-color: #536dfe; /*#edeef3;*/
  color: #fff;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12) !important;
  text-align: center;
  padding: 8px 0;
  border-radius: 10px;
  margin-bottom: 6px;
}
.theme--dark .calendar div {
  background-color: rgba(255,255,255,0.05);
  background-color: #64b5f6;
  color: #000;
}
.calendar div.on, .calendar div.selected {
  background-color: #ef3024;
  color: #fff;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12) !important;
}
.theme--dark .calendar div.on, .theme--dark .calendar div.selected {
  background-color: #ef5350;
}
.theme--light.v-chip:not(.v-chip--active).transparent {
  background: transparent;
}
</style>